import MediaBrowser from 'components/shared/MediaBrowser/MediaBrowser'
import MediaListItem from 'components/shared/MediaBrowser/MediaListItem'
import config from 'config/config'

import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { formValues } from 'redux-form'
import { Grid, Segment, Table } from 'semantic-ui-react'

const i18nkey = 'admin.product.categories.media.'

const mapStateToProps = (state, ownProps) => {
  const { category } = state.categories
  const { media } = state.media
  const headerMedium = media.find(
    (medium) => medium.id === ownProps.headerMediumId
  )
  const thumbnailMedium = media.find(
    (medium) => medium.id === ownProps.thumbnailMediumId
  )
  return { category, headerMedium, thumbnailMedium }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch)
}

class CategoryMedia extends React.Component {
  customActions(medium) {
    const { change } = this.props
    return [
      {
        icon: 'image',
        disabled: medium.content_type === 'application/pdf',
        text: I18n.t(i18nkey + 'as_header'),
        onClick: (event) => {
          event.preventDefault()
          change('headerMediumId', medium.id)
        },
      },
      {
        icon: 'image',
        disabled: medium.content_type === 'application/pdf',
        text: I18n.t(i18nkey + 'as_thumbnail'),
        onClick: (event) => {
          event.preventDefault()
          change('thumbnailMediumId', medium.id)
        },
      },
    ]
  }

  render() {
    const dark = config.theme.dark

    const { headerMedium, thumbnailMedium, change } = this.props

    const headerImageProps = {
      medium: headerMedium,
      action: () => change('headerMediumId', null),
      title: I18n.t(i18nkey + 'header'),
    }

    const thumbnailProps = {
      medium: thumbnailMedium,
      action: () => change('thumbnailMediumId', null),
      title: I18n.t(i18nkey + 'thumbnail'),
    }

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={12}>
            <Segment
              attached
              className={classNames(['payload', dark && 'inverted'])}>
              <Table
                fixed
                compact
                size="small"
                selectable
                singleLine
                basic="very"
                className="spaced mediaList categoryMedia">
                <Table.Body>
                  <MediaListItem {...headerImageProps} />
                  <MediaListItem {...thumbnailProps} />
                </Table.Body>
              </Table>
            </Segment>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={12}>
            <MediaBrowser
              {...{
                addMedium: (mediumId) => undefined,
                customActions: (medium) => this.customActions(medium),
                allowedTypes: ['image/jpeg', 'image/png'],
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

CategoryMedia = connect(mapStateToProps, mapDispatchToProps)(CategoryMedia)
CategoryMedia = formValues('headerMediumId', 'thumbnailMediumId')(CategoryMedia)
export default CategoryMedia



// WEBPACK FOOTER //
// ./src/components/admin/Categories/CategoryMedia.jsx